import React from "react";
import type { KeyInsight } from "../types/merchant-home-data.types";

interface KeyInsightsProps {
  insights: KeyInsight[];
}

export const KeyInsights: React.FC<KeyInsightsProps> = ({ insights }) => {
  const getIcon = (iconType: KeyInsight["icon_type"]) => {
    switch (iconType) {
      case "trend":
        return (
          <div className="w-5 h-5 relative">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
            >
              <path
                d="M3.33333 14.1667L8.33333 9.16667L12.5 13.3333L16.6667 9.16667"
                stroke="#16a34a"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="dark:stroke-green-400"
              />
              <path
                d="M13.3333 9.16667H16.6667V12.5"
                stroke="#16a34a"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="dark:stroke-green-400"
              />
            </svg>
          </div>
        );
      case "clock":
        return (
          <div className="w-5 h-5 relative">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
            >
              <circle
                cx="10"
                cy="10"
                r="6.66667"
                stroke="#9333ea"
                strokeWidth="1.67"
                className="dark:stroke-purple-400"
              />
              <path
                d="M10 6.66667V10L13.3333 13.3333"
                stroke="#9333ea"
                strokeWidth="1.67"
                strokeLinecap="round"
                className="dark:stroke-purple-400"
              />
            </svg>
          </div>
        );
      case "calendar":
        return (
          <div className="w-5 h-5 relative">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
            >
              <rect
                x="3.33333"
                y="4.16667"
                width="13.3333"
                height="12.5"
                rx="1.66667"
                stroke="#2563eb"
                strokeWidth="1.67"
                className="dark:stroke-blue-400"
              />
              <path
                d="M6.66667 2.5V5.83333M13.3333 2.5V5.83333M3.33333 8.33333H16.6667"
                stroke="#2563eb"
                strokeWidth="1.67"
                className="dark:stroke-blue-400"
              />
            </svg>
          </div>
        );
      default:
        return (
          <div className="w-5 h-5 relative">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
            >
              <path
                d="M3.33333 14.1667L8.33333 9.16667L12.5 13.3333L16.6667 9.16667"
                stroke="#16a34a"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="dark:stroke-green-400"
              />
              <path
                d="M13.3333 9.16667H16.6667V12.5"
                stroke="#16a34a"
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="dark:stroke-green-400"
              />
            </svg>
          </div>
        );
    }
  };

  const getIconBg = (iconType: KeyInsight["icon_type"]) => {
    switch (iconType) {
      case "trend":
        return "bg-green-50 dark:bg-green-900/30";
      case "clock":
        return "bg-purple-50 dark:bg-purple-900/30";
      case "calendar":
        return "bg-blue-50 dark:bg-blue-900/30";
      default:
        return "bg-green-50 dark:bg-green-900/30";
    }
  };

  return (
    <div className="flex-1 self-stretch p-6 bg-white dark:bg-gray-800 rounded-2xl outline outline-1 outline-offset-[-1px] outline-gray-200 dark:outline-gray-700 inline-flex flex-col justify-start items-start gap-4">
      <div className="w-full inline-flex justify-start items-center gap-2">
        <div
          className="flex-1 justify-center text-[#004232] dark:text-emerald-400 text-xl font-normal leading-8"
          style={{ fontFamily: "Cal Sans" }}
        >
          Key Insights
        </div>
      </div>
      <div className="w-full flex flex-col justify-start items-start gap-3">
        {insights.map((insight) => (
          <div
            key={insight.id}
            className="self-stretch p-4 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-neutral-200 dark:outline-gray-600 inline-flex justify-start items-center gap-3"
          >
            <div
              className={`p-2 ${getIconBg(insight.icon_type)} rounded-[10px] inline-flex flex-col justify-start items-start`}
            >
              {getIcon(insight.icon_type)}
            </div>
            <div
              className="justify-center text-gray-600 dark:text-gray-300 text-sm font-normal leading-6"
              style={{ fontFamily: "Nunito" }}
            >
              {insight.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
